var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h3',{class:_vm.theme},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('img',{attrs:{"src":_vm.srcBg}})])}
var staticRenderFns = []

export { render, staticRenderFns }